import React, { useState } from 'react';

import { withQueryparams } from '@/main/components/core/queryParams/queryparams';
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { getTranslateByKey } from '@/main/services/utils';
import FiltersReportTemplateWrapper from './filtersReportTemplate/filtersReportTemplate';
import { ReportTemplateGridResponse } from '@/main/models/response';
import { ReportTemplateFilterRequest } from '@/main/models/request';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import GridSearchReportTemplate from './gridReportTemplate/gridReportTemplate';

function ReportTemplateScreen() {
  const titlePage = `${getTranslateByKey(
    'information.registration'
  )} > ${getTranslateByKey('information.searchReportTemplate')}`;

  const [dataGrid, setDataGrid] = useState<ReportTemplateGridResponse[]>([]);
  const [
    formFilters,
    setFormFilters
  ] = useState<ReportTemplateFilterRequest | null>(null);

  function onResetSearch() {
    setDataGrid([]);
    setFormFilters(null);
  }

  async function getDataReportTemplate(
    filters:
      | ReportTemplateFilterRequest
      | Partial<ReportTemplateFilterRequest> = {},
    isResetSearch: boolean = true
  ) {
    const request: ReportTemplateFilterRequest = {
      ...(isResetSearch ? {} : formFilters),
      ...(filters as ReportTemplateFilterRequest),
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30
    };

    onResetSearch();
    setFormFilters(request);
  }

  return (
    <ContainerScreen title={titlePage}>
      <FiltersReportTemplateWrapper
        onResetSearch={onResetSearch}
        getDataReportTemplate={getDataReportTemplate}
      />
      <GridSearchReportTemplate
        dataGrid={dataGrid}
        formFilters={formFilters}
        setDataGrid={setDataGrid}
      />
    </ContainerScreen>
  );
}

export default withQueryparams(ReportTemplateScreen);
